import createGradientTexture from './createGradientTexture';
import scaleToWindow from './scaleToWindow';

export { createGradientTexture, scaleToWindow };


// WEBPACK FOOTER //
// ./src/lib/index.ts